import { Injectable } from '@angular/core';
import { WomanDietTypes } from 'src/app/core/model/diet-type-model';

@Injectable({
  providedIn: 'root',
})
export class DietTypeService {
  constructor() {}

  getDietTypeNameById(id: number): string {
    let name = '';
    WomanDietTypes.forEach((type) => {
      if (type.getID() === id) {
        name = type.getName();
      }
    });
    return name;
  }

  getDietTypeIdByEngName(name: string): number {
    let id = -1;
    WomanDietTypes.forEach((type) => {
      if (type.getEngName() === name) {
        id = type.getID();
      }
    });
    return id;
  }

  getDietTypeNameByEngName(engName: string): string {
    let name = '';
    WomanDietTypes.forEach((type) => {
      if (type.getEngName() === engName) {
        name = type.getName();
      }
    });
    return name;
  }
}
